import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";

const IconUmrah = ({ size, ...props }) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...(size !== undefined && { width: size, height: size })}
		{...props}
	>
		<path
			d="M20.25 8.06069L21.75 8.40254V5.99023L21.75 5.94424C21.7501 5.61317 21.7501 5.30355 21.7197 5.04492C21.6856 4.75461 21.6051 4.44911 21.3926 4.16895C21.18 3.88907 20.9079 3.73085 20.6377 3.62012C20.3917 3.51933 20.0863 3.43433 19.7604 3.34361L19.7363 3.33691L12.7363 1.38867L12.6834 1.37385C12.4708 1.3142 12.242 1.25 12 1.25C11.758 1.25 11.5292 1.3142 11.3166 1.37385L11.2637 1.38867L4.26367 3.33691L4.23996 3.34351C3.91386 3.43427 3.60835 3.5193 3.3623 3.62012C3.09189 3.73094 2.81904 3.88882 2.60645 4.16895C2.39395 4.4491 2.3144 4.75463 2.28027 5.04492C2.24987 5.3036 2.24993 5.61332 2.24999 5.94449L2.25 5.99023V8.40472L3.75 8.06251L11.3994 6.31739C11.7948 6.22733 12.2052 6.22733 12.6006 6.31739L20.25 8.06069Z"
			fill="black"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.75 11.9353V21H11.25V11.9353C10.85 12.017 10.4571 11.7624 10.3682 11.3623C10.2785 10.9581 10.5333 10.5576 10.9375 10.4678L11.25 10.3983V7.89034L3.75 9.60154L2.25 9.94378V12.4023L3.75 12.0659L4.1875 11.9678C4.59171 11.8781 4.9921 12.1329 5.08203 12.5371C5.17189 12.9415 4.91704 13.3428 4.51269 13.4326L3.75 13.6037L2.25 13.9402V21H2C1.44772 21 1 21.4477 1 22C1 22.5523 1.44772 23 2 23H22C22.5523 23 23 22.5523 23 22C23 21.4477 22.5523 21 22 21H21.75V13.9344L20.25 13.6017L19.4873 13.4326C19.083 13.3428 18.8281 12.9415 18.918 12.5371C19.0079 12.1329 19.4083 11.8781 19.8125 11.9678L20.25 12.0648L21.75 12.3973V9.9415L20.25 9.59962L12.75 7.89023V10.3983L13.0625 10.4678C13.4667 10.5576 13.7215 10.9581 13.6318 11.3623C13.5429 11.7624 13.15 12.017 12.75 11.9353ZM15.7627 11.0674C15.3584 10.9776 14.958 11.2334 14.8682 11.6377C14.7785 12.0419 15.0333 12.4424 15.4375 12.5322L16.3369 12.7324C16.7412 12.8223 17.1424 12.5673 17.2324 12.1631C17.3223 11.7588 17.0673 11.3576 16.6631 11.2676L15.7627 11.0674ZM9.13184 11.6377C9.04199 11.2334 8.64162 10.9776 8.23731 11.0674L7.33691 11.2676C6.93274 11.3576 6.67774 11.7588 6.76758 12.1631C6.85757 12.5673 7.25884 12.8223 7.66308 12.7324L8.5625 12.5322C8.96675 12.4424 9.22149 12.0419 9.13184 11.6377Z"
			fill="black"
		/>
	</svg>
);

IconUmrah.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default IconUmrah;
